import React from 'react';

import { ReactComponent as ErrorLogo } from 'icons/errorLogo.svg';
import {
    Blankspace,
    IconContainer,
    IconShadow,
    IconWrapper,
    ErrorWrapper,
    ErrorMainText,
    ErrorSubText,
} from './Error.styles';

export default function ErrorDisplay(): JSX.Element {
    return (
        <ErrorWrapper>
            <Blankspace />
            <IconContainer>
                <IconShadow />
                <IconWrapper>
                    <ErrorLogo />
                </IconWrapper>
            </IconContainer>
            <ErrorMainText>
                Whoops! Looks like we&apos;ve run into an issue...
            </ErrorMainText>
            <ErrorSubText>Apologies for the inconvenience.</ErrorSubText>
            <ErrorSubText>
                Contact our Support team or your administrator for assistance.
            </ErrorSubText>
            <ErrorSubText>
                Please stay on this page as it will help our troubleshooting efforts.
            </ErrorSubText>
        </ErrorWrapper>
    );
}
